/* Deferred card hydration for collection grids.

   The server ships only the first 25 cards (templates/collection.*.liquid); the rest come
   from the collection's ?view=cards alternate template right after load, as detached nodes.
   Everything downstream — the filter facets, the result counts, sort, and the Show More cap
   — still operates on the whole collection, so behaviour is unchanged; only the document
   got smaller. Consumers wait via EFCollectionRest.ready(cb).

   Load order matters: this must run before ef-collection-filter.js and ef-collection-more.js. */
(function () {
  'use strict';

  var GRID = '.ef-coll-grid';
  var CARD = '.ef-coll-card';

  var waiting = [];
  var settled = false;

  var api = {
    cards: [],
    ready: function (cb) {
      if (settled) cb(api.cards);
      else waiting.push(cb);
    }
  };
  window.EFCollectionRest = api;

  function settle(rest) {
    var grid = document.querySelector(GRID);
    var inDom = grid ? Array.prototype.slice.call(grid.querySelectorAll(CARD)) : [];
    api.cards = inDom.concat(rest || []);
    settled = true;
    waiting.splice(0).forEach(function (cb) { cb(api.cards); });
  }

  /* Fetch failed and there is no other route to products 26+. The template keeps a plain
     link list in a <noscript> for no-JS agents; with scripting on, its children are inert
     text, so re-parse it into the page rather than stranding the visitor on 25 cards. */
  function revealFallbackLinks() {
    var ns = document.querySelector('[data-ef-rest-links]');
    if (!ns || !ns.parentNode) return;
    var holder = document.createElement('div');
    holder.className = 'ef-coll-rest-fallback';
    holder.innerHTML = ns.textContent;
    ns.parentNode.insertBefore(holder, ns);
  }

  function start() {
    var wrap = document.querySelector('[data-ef-more]');
    var url = wrap && wrap.getAttribute('data-ef-rest-url');
    if (!url || !window.fetch || !window.DOMParser) {
      settle([]);
      return;
    }
    /* Low priority on purpose: nothing here is on screen until Show More or a filter
       click, so it must not compete with the eager first-row card images. */
    fetch(url, { credentials: 'same-origin', priority: 'low' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        /* Adopted but never connected until Show More/filter inserts them, so the lazy
           images inside stay unfetched. */
        settle(Array.prototype.slice.call(doc.querySelectorAll(CARD)).map(function (node) {
          return document.adoptNode(node);
        }));
      })
      .catch(function () {
        revealFallbackLinks();
        settle([]);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
